/**
 * 查看详情
 * 2017-12-27
 * by 于再洋
 */
"use strict";
angular.module("delModule", []).
controller("delCtrl", ["$scope", '$modalInstance', 'trsHttpService', 'item', 'trsconfirm', "$document","$timeout", function($scope, $modalInstance, trsHttpService, item, trsconfirm, $document,$timeout) {
	initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            pageNo:0,
            pageSize:10,
        };
        $scope.data = {
            items: item,
        };
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
    }
    /**
     * [deleteData description] 删除数据请求
     */
    $scope.deleteData = function() {
        var params = {
             "typeid": 'screen',
             "serviceid": 'zjsentimentrulemgr',
             "modelid": 'deleterule',
             'id':$scope.data.items.id,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            //console.log(data);
        });
        $modalInstance.close(true);
    }
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

}]);